import React from 'react'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import BlogContainer from '../../components/BlogContainer'
import PageTop from '../../components/PageTop'
import useFetchInfo from '../../hooks/useFetchInfo.hook'
import { useLangContext } from '../../i18n/ProvideLang'
import ArticleServices from '../../services/general/articleServices'
import { Helmet } from 'react-helmet'

const BlogDetail = () => {
  const {slug} = useParams();
  const {lang} = useLangContext();
  const navigate = useNavigate();
  const {lang: lang2} = useParams();

  const {info, loading} = useFetchInfo(ArticleServices.view, slug);

  useEffect(() => {
    if(lang){
        if(lang !== lang2) {
            navigate(`/${lang}/articles/${slug}`)
        }
    }
  }, [lang])


  return (
    <>
      <Helmet>
        <title>{info?.title}</title>
      </Helmet>
      {loading ?
        <div className="preloader">
          <div className="isLoading"></div>
        </div>
      :
        <div>
            <PageTop item={info}/>
            {info && <BlogContainer info={info}/>}
        </div>
      }
    </>
  )
}

export default BlogDetail